import { createFileRoute } from '@tanstack/react-router'

import { Home } from '@/features/brief/Home'
import { VisitorOnly } from '@/features/identity/VisitorOnly'

export const Route = createFileRoute('/')({
  component: HomeRoute,
})

/**
 * The bare domain: what Scout is, and the way in.
 *
 * Kept as a page rather than made a redirect, because this is where somebody
 * arriving from outside lands, and it is the only place that says what Scout is
 * before asking them to start anything. A member is sent on: this page offers
 * the anonymous kind of brief, which is not the kind they can have.
 */
function HomeRoute() {
  return (
    <VisitorOnly>
      <Home />
    </VisitorOnly>
  )
}
